import { fetcher } from '@/api/fetcher/fetcher'

function fetchMeetingList({ queryKey }) {
  const limit = queryKey[1].reactiveLimit
  const sortedBy = queryKey[1].reactiveSortedBy ? queryKey[1].reactiveSortedBy : undefined
  const orderBy = queryKey[1].reactiveOrderBy ? queryKey[1].reactiveOrderBy : undefined
  const page = queryKey[1].reactivePage ? queryKey[1].reactivePage.page : ''
  const status = queryKey[1].reactiveStatus ? queryKey[1].reactiveStatus : ''
  const search = queryKey[1].reactiveSearch ? queryKey[1].reactiveSearch : ''
  const searchFields = queryKey[1].reactiveSearchFields ? queryKey[1].reactiveSearchFields : ''
  const advisor_id = queryKey[1].reactiveAdvisorId

  const include = undefined
  const searchJoin = 'and'

  const searchParams = {
    search,
    searchFields,
    orderBy,
    include,
    limit,
    searchJoin,
    advisor_id,
    page,
    sortedBy,
  }

  if (status) {
    searchParams.status = status
  }

  return fetcher({
    url: `/meeting_note/all/${advisor_id}`,
    options: { method: 'GET', searchParams },
  })
}

export { fetchMeetingList }
